import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export function scrollFadeIn() {
  //fade in batch - from bottom
  const fadeinBatch = document.querySelectorAll("[js-scroll_fadein='batch']");
  if (fadeinBatch) {
    gsap.set(fadeinBatch, { opacity: 0, y: 40 })
    ScrollTrigger.batch("[js-scroll_fadein='batch']", {
      start: "top 85%",
      invalidateOnRefresh: true,
      // markers: true,
      onEnter: (elements, triggers) => {
        gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15, duration: 0.7 });
        // console.log(elements.length, "elements entered");
      },
      onLeaveBack: (elements, triggers) => {
        gsap.to(elements, { opacity: 0, y: 40, stagger: 0.15, duration: 0.7 });
        // console.log(elements.length, "elements leave back");
      },
    });
  }
  //fade in from bottom
  const fadeinBottom = gsap.utils.toArray("[js-scroll_fadein='bottom']");
  if (fadeinBottom) {
    fadeinBottom.forEach((el, i) => {
      ScrollTrigger.create({
        trigger: el,
        start: "top 85%",
        invalidateOnRefresh: true,
        // markers: true,
        onEnter: () => {
          gsap.to(el, { opacity: 1, y: 0, duration: 0.7 });
          el.classList.add("fade-in");
          // console.log(el, "elements entered");
        },
        onLeaveBack: () => {
          gsap.to(el, { opacity: 0, y: 40, duration: 0.7 });
          el.classList.remove("fade-in");
          // console.log(el, "elements leave back");
        },
      });
    });
  }
  //fade in from left
  const fadeinLeft = gsap.utils.toArray("[js-scroll_fadein='left']");
  if (fadeinLeft) {
    fadeinLeft.forEach((el, i) => {
      ScrollTrigger.create({
        trigger: el,
        start: "top 85%",
        invalidateOnRefresh: true,
        // markers: true,
        onEnter: () => {
          gsap.to(el, { opacity: 1, x: 0, duration: 0.7 });
          el.classList.add("fade-in");
          // console.log(el, "elements entered");
        },
        onLeaveBack: () => {
          gsap.to(el, { opacity: 0, x: -40, duration: 0.7 });
          el.classList.remove("fade-in");
          // console.log(el, "elements leave back");
        },
      });
    });
  }
  //fade in from right
  const fadeinRight = gsap.utils.toArray("[js-scroll_fadein='right']");
  if (fadeinRight) {
    fadeinRight.forEach((el, i) => {
      ScrollTrigger.create({
        trigger: el,
        start: "top 85%",
        invalidateOnRefresh: true,
        // markers: true,
        onEnter: () => {
          gsap.to(el, { opacity: 1, x: 0, duration: 0.7 });
          el.classList.add("fade-in");
          // console.log(el, "elements entered");
        },
        onLeaveBack: () => {
          gsap.to(el, { opacity: 0, x: 40, duration: 0.7 });
          el.classList.remove("fade-in");
          // console.log(el, "elements leave back");
        },
      });
    });
  }

  //fade in Bg image - from bottom
  const fadeinsScales = document.querySelectorAll("[js-scroll_fadein='scale']");
  if (fadeinsScales) {
    fadeinsScales.forEach((el, i) => {
      gsap.fromTo(el, {
        scale: 1.2,
      }, {
        scale: 1,
        scrollTrigger: {
          trigger: el,
          start: "top 90%",
          end: "+=100%",
          scrub: true,
          ease: 'power3',
          // markers: true,
        }
      })
    })
  }
}
